import React from 'react';
import { Zap } from 'lucide-react';

// Modal-form entry point for conditional follow-ups (replaces the old inline "Conditional Logic" builder).
// Opens the ConditionalInjectPicker for the card being edited.
export const ConditionalFollowupTrigger = ({ editingItem, onAddConditional }) => (
  <div className="rounded-lg border border-amber-200 bg-amber-50/60 p-3" data-testid="modal-conditional-trigger">
    <div className="flex items-center gap-2 mb-1">
      <Zap className="h-4 w-4 text-amber-600" />
      <span className="text-sm font-bold text-amber-900">Conditional follow-ups</span>
    </div>
    <p className="text-[12px] text-amber-700/80 mb-2">
      Automatically inject another card when this one meets a condition (timeout, completed, or outcome).
    </p>
    {editingItem?.id ? (
      <button
        type="button"
        data-testid="modal-add-conditional-btn"
        onClick={() => onAddConditional?.(editingItem)}
        className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-amber-300 bg-white px-3 py-1.5 text-[12px] font-semibold text-amber-700 hover:bg-amber-100 hover:border-amber-400 transition-colors"
      >
        <Zap className="h-3.5 w-3.5" /> Add conditional follow-up
      </button>
    ) : (
      <p className="text-[11px] text-amber-600 italic">Save this card first, then add conditional follow-ups.</p>
    )}
  </div>
);

export default ConditionalFollowupTrigger;
